
import React, { useMemo } from "react";

interface StarProps {
  count: number;
}

const StarryBackground: React.FC<StarProps> = ({ count }) => {
  const stars = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => ({
      id: i,
      size: Math.random() * 2 + 1,
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      animationDuration: `${Math.random() * 3 + 2}s`,
      animationDelay: `${Math.random() * 5}s`,
    }));
  }, [count]);

  return (
    <div className="fixed inset-0 z-0 overflow-hidden bg-gradient-to-b from-[#0D1117] to-[#1A1F2C]">
      {stars.map((star) => (
        <div
          key={star.id}
          className="absolute rounded-full bg-white"
          style={{
            top: star.top,
            left: star.left,
            width: `${star.size}px`,
            height: `${star.size}px`,
            opacity: Math.random() * 0.7 + 0.3,
            animation: `twinkle ${star.animationDuration} ease-in-out infinite ${star.animationDelay}`,
          }}
        />
      ))}
      <div className="absolute inset-0 bg-[#8B5CF608] pointer-events-none"></div>
    </div>
  );
};

export default StarryBackground;
